import type { Event } from '@patsnap/tahiti-core';
import type { Permission } from '../types';

export const PermissionService = Symbol.for('PermissionService');

export interface PermissionService {
    readonly onStatesChange: Event<Permission>;

    getModelData(): Permission;
    updatePermission(permissions: Permission): void;
}
